/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdatePayersForCustomerRequest} from '@cash-web/protos/squareup/cash/paychecks/api/v1/paychecks_app_service.pb'
import {UpdatePayersForCustomerResponse} from '@cash-web/protos/squareup/cash/paychecks/api/v1/paychecks_app_service.pb'


export const updatePayersForCustomer = (request: UpdatePayersForCustomerRequest, options?: CashRequestOptions) => post<UpdatePayersForCustomerRequest, UpdatePayersForCustomerResponse>("/2.0/cash/update-payers-for-customer", request, {...options, rejectOnError: true })